var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.824 30.21C-2.606 17.408 4.99 4.252 17.79.823a23.927 23.927 0 019.588-.584 3.877 3.877 0 013.29 4.382 3.868 3.868 0 01-4.376 3.29 16.196 16.196 0 00-6.496.398C11.124 10.633 5.978 19.542 8.3 28.207c2.322 8.664 11.232 13.807 19.905 11.483 8.672-2.324 13.818-11.233 11.496-19.897a3.873 3.873 0 012.735-4.745 3.873 3.873 0 014.742 2.741c3.43 12.802-4.168 25.958-16.967 29.387C17.41 50.606 4.254 43.011.824 30.21zm32.672-20.13a4.085 4.085 0 01.41-3.11 4.086 4.086 0 012.09-1.78l.399-.13a4.086 4.086 0 013.11.41 4.084 4.084 0 011.91 2.488 4.084 4.084 0 01-.41 3.11 4.086 4.086 0 01-2.49 1.909 4.087 4.087 0 01-3.11-.41 4.085 4.085 0 01-1.909-2.488z"
  })));
}

export default SvgLogoMark;